import React, {useState, Fragment} from 'react';
import { Card, CardContent } from '@mui/material';
import {  NavigateBefore, NavigateNext, Visibility } from '@mui/icons-material';
import Formulario from 'components/formulario';
import { useDispatch } from 'react-redux';
import { setearDatosAlStore, obtenerRegistrosPorURL } from 'store/actions/customAction';
import { nombreDeAcciones } from 'constantes/nombreDeAcciones';
import Base64Pdf from 'components/base64pdf';
import { functions } from 'constantes/functions';


const PersonaQueEmiteFactura = ({activeStep, numberStep, personaIndividual, idSolicitud}) => {

    const dispatch = useDispatch();

    const { nit, nombreEmiteFactura, constanciaRTU, noRegistro, numeroResolucion, folioRGAE, constanciaRGAE } = personaIndividual;

    const [docAdjunto, setDocAdjunto] = useState({title: '', pdf: ''});
    const [mostrarDoc, setMostrarDoc] = useState(false);

    const cerrarDoc = () => setMostrarDoc(false);
    const descargarDoc = () => functions.descargarBase64EnPDF(docAdjunto.pdf, `${docAdjunto.title}.pdf`);

    const obtenerPDFDelServidor = async (tipoDeArchivo) => {
        const respuesta = await dispatch(obtenerRegistrosPorURL({
            controller: 'formularioDeRegistroDeMediosDeComunicacion',
            saveInStore: false,
            nombreDelMetodo: `obtenerArchivo/${tipoDeArchivo}`,
            parametro: idSolicitud
        }));
        if (!respuesta?.data) return;
        setDocAdjunto({title: tipoDeArchivo, pdf: respuesta.data});
        setMostrarDoc(true);
    };

    const [elementosDelFormulario] = useState(() => {
        const elementos = {
        constaciaRTUTitulo:{
            idelement: "constaciaRTUTitulo",title:'Constancia de Inscripción del Registro Tributario Unificado - RTU', position:"center", value: "", isError:false, elementType:'titulo', showTitleForm: true,  name: "constaciaRTUTitulo",
        },
        nit:{
            idelement: "nit", value: nit, label: "Ingrese el NIT sin guiones del solicitante*",  pattern:"^([0-9]{1,})+([a-zA-Z]{1})?$", validators: ['required'],
            errorMessages:['El campo es requerido'], isError:false, elementType:'texto', name:"nit",'disabled': !!nit && !idSolicitud, autofocus: true, keyPress: undefined
        },
        nombreEmiteFactura: {
            idelement: "nombreEmiteFactura",  value: nombreEmiteFactura, label: "Nombre de la entidad / solicitante *",  pattern:"^([a-zA-ZÀ-ÿñÑ\.,]{1,})([ ][a-zA-ZÀ-ÿñÑ\.,]{1,}){0,}$", validators: ['required'], errorMessages:['El campo es requerido'], isError:false, elementType:'texto', name:"nombreEmiteFactura",  autofocus: false,
        },
        constanciaRTU:{
            idelement: "constanciaRTU", value: constanciaRTU, label: "Ingrese en PDF constancia de RTU *", validators: {required: idSolicitud ? false : true,  size: "10 MB",}, errorMessages: 'Por favor debe adjuntar lo solicitado', isError:false, elementType:'archivo','disabled':false, name:"constanciaRTU", fileWidth: true, src: '', multiple: false, accept:".pdf", showInMovil: true, type: "file", showButtonEditDocument: true, firstTitle: "constanciaRTU", iconButton: <Visibility />, handleVisualization: idSolicitud ? () => obtenerPDFDelServidor('constanciaRTU') : () => {}, nameOfFile: idSolicitud ? 'Archivo guardado en servidor' : undefined, disabledVisualization: !!idSolicitud, fileType: "pdf"
        },
        constanciaRGAETitulo:{
            idelement: "constanciaRGAETitulo",title:'Constancia RGAE', position:"center", value: "", isError:false,  elementType:'titulo', showTitleForm: true, name: "constanciaRGAETitulo",
        },
        noRegistro:{
            idelement: "noRegistro", value: noRegistro, label: "Ingrese el número de expediente *", pattern:"^[\-0-9_\/|a-zA-Z]+$", validators: ['required'],
            errorMessages:['El campo es requerido'], isError:false, elementType:'texto', name:"noRegistro", 'disabled':false, autofocus: false, keyPress: undefined
        },
        numeroResolucion: {
            idelement: "numeroResolucion",  value: numeroResolucion, label: "Número de resolución *", pattern:"^[\-0-9_\/|a-zA-Z]+$", validators: ['required'], errorMessages:['El campo es requerido'], isError:false, elementType:'texto', name:"numeroResolucion", autofocus: false,
        },
        folioRGAE:{
            idelement: "folioRGAE", value: folioRGAE, label: "Folio *", pattern:"^[\-0-9_\/|a-zA-Z]+$", validators: ['required'],
            errorMessages:['El campo es requerido'], isError:false, elementType:'texto',name:"folioRGAE", 'disabled':false,
        },
        constanciaRGAE:{
            idelement: "constanciaRGAE", value: constanciaRGAE, label: "Ingrese el PDF resolución y constancia de RGAE",
            validators: {required:  idSolicitud ? false : true,  size: "10 MB",}, errorMessages: 'Por favor debe adjuntar lo solicitado', isError:false, elementType:'archivo','disabled':false, name:"constanciaRGAE", fileWidth: true, src: '', multiple: false, accept:".pdf", showInMovil: true, type: "file", showButtonEditDocument: true, firstTitle: "constanciaRGAE", iconButton: <Visibility />, handleVisualization: idSolicitud ? () => obtenerPDFDelServidor('pdfResolucion') : () => {}, nameOfFile: idSolicitud ? 'Archivo guardado en servidor' : undefined, disabledVisualization: !!idSolicitud, fileType: "pdf"
        },
        };

        Object.keys(elementos).forEach((key) => {
            if (["texto", "areaTexto"].includes(elementos[key]?.elementType)) {
                elementos[key].transformToUppercase = true;
            }
        });

        return elementos;
    });

    const siguientePaso = async (dataForm) => {
        await dispatch(setearDatosAlStore({
            dispatchAction : nombreDeAcciones.SET_DATA_PERSON_ISSUING_THE_INVOICE,
            data: {
                personaIndividual: dataForm,
                activeStep : activeStep + 1,
                numberStep : numberStep + 1
            }
        }));
    }

    const actionRegresar = () => {
        dispatch(setearDatosAlStore({
            dispatchAction : nombreDeAcciones.SET_DATA_ACTIVE_AND_NUMBER_STEP,
            data: {
                activeStep : activeStep - 1,
                numberStep : numberStep - 1
            }
        }));
    };

    const [listadoDeBotones]= React.useState({
        "backAction":{"label":"Regresar", "icon": <NavigateBefore />,"callback":actionRegresar,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false,
                isCancel: true,
        },
        "saveData":{"label":"Siguiente", "icon": <NavigateNext />, "callback":siguientePaso,"loading":false,"size":"medium",
        "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
        "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
        isCancel: false,
        },
    });

    return (
        <Fragment>
            <Card>
                <CardContent>
                    <Formulario
                        elements={elementosDelFormulario}
                        buttonList={listadoDeBotones}
                    />
                </CardContent>
            </Card>
            {mostrarDoc && (
                <Base64Pdf pdf={docAdjunto.pdf} title={docAdjunto.title} open={mostrarDoc} handleClose={cerrarDoc} showDownloadButton={true} src={docAdjunto.pdf} DescargarPDF={descargarDoc} />
            )}
        </Fragment>
    );
}

export default PersonaQueEmiteFactura;